import { EnvConfig } from '../types';
import { config as configProd } from './prod';

const prEnv = process.env.REACT_APP_IS_PR_ENV === 'true';
const baseDomain = !prEnv ? 'app.s.alloyads.ai' : window.location.host.replace(/^pr-\d+-/i, '');

export const config: EnvConfig = {
  ...configProd,
  env: 'stg',
  api: {
    ...configProd.api,
    baseUrl: `https://${baseDomain}/api`,
  },
};
